import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { HiddenInviteCode, HiddenProduct, HiddenRedirect, HiddenXSRF } from './forms';
import DangerString from './danger-string';
import WaitButton from './wait-button';

function SSOLoginForm(props) {
  const { context, idp, name } = props;

  const [pending, setPending] = useState(false);

  return (
    <form action='/login/sso' method='post' onSubmit={() => setPending(true)}>
      <input type='hidden' name='idp' value={idp} />
      <HiddenInviteCode />
      <HiddenProduct />
      <HiddenRedirect />
      <HiddenXSRF />

      <p><DangerString stringKey={`sso.details.${context}`} placeholders={{ name }} /></p>
      
      <fieldset className='actions noMarginAbove'>
        <WaitButton autoFocus className='letWrap' type='submit' wait={pending} >
          <DangerString stringKey='sso.submit' placeholders={{ name }} />
        </WaitButton>
      </fieldset>
    </form>
  );
}

SSOLoginForm.propTypes = {
  context: PropTypes.string,
  idp: PropTypes.string,
  name: PropTypes.string
};

export default SSOLoginForm;
